import React, { useState, useEffect } from "react";
import "./faq.css";
import { FaArrowRight } from "react-icons/fa";
import AOS from "aos";
import "aos/dist/aos.css";

const faqData = [
  {
    question: "What services does your company provide?",
    answer:
      "We specialize in website design, SEO, logo design, and comprehensive digital marketing solutions to help businesses grow online.",
  },
  {
    question: "What is included in your digital marketing?",
    answer:
      "Our digital marketing includes SEO, social media management, PPC advertising, content creation, and analytics reporting.",
  },
  {
    question: "Can I see samples of logos you’ve designed?",
    answer:
      "Yes, we can share our portfolio of logo designs upon request to help you get an idea of our creative style.",
  },
  {
    question: "Do you provide ongoing website maintenance?",
    answer:
      "Absolutely! We offer maintenance packages to ensure your website stays updated, secure, and optimized.",
  },
  {
    question: "Do you offer customized SEO strategies?",
    answer:
      "Yes, our SEO strategies are tailored to your business goals, target audience, and industry trends.",
  },
  {
    question: "Can you help us with social media ads?",
    answer:
      "Definitely! We create and manage social media ad campaigns on platforms like Facebook, Instagram, and LinkedIn.",
  },
  {
    question: "Do I need to provide content for my website?",
    answer:
      "We can create professional content for you, but if you already have content, we’ll use and optimize it for the web.",
  },
  {
    question: "How do I know if SEO is working for my website?",
    answer:
      "We provide regular SEO reports that show your keyword rankings, traffic growth, and performance improvements.",
  },
];

function FAQ() {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  // Initialize AOS animations
  useEffect(() => {
    AOS.init({
      duration: 1000, // fade timing
      once: true, // animate only once
      easing: "ease-in-out",
    });
  }, []);

  return (
    <>
      <div className="faq-section-contact">
        {/* Header Section */}
        <div className="about-header" data-aos="fade-down">
          <span className="about-breadcrumb">
            <a style={{ color: "#3a3a5e" }} href="/home">
              Home
            </a>{" "}
            <FaArrowRight /> <a href="/aboutus">FAQ's</a>
          </span>

          <h1 className="about-heading">
            FAQ's
          </h1>
          <p className="about-description" >
            Your questions answered, your goals achieved!
          </p>
        </div>

        {/* Intro Section */}
        <div className="container">
          <div className="contact-us-section faq-sec" data-aos="fade-right">
            <h5>Any Help?</h5>
            <h2>Frequently Asked Questions</h2>
            <p>
              Find answers to common questions about our services, process, and
                <br class="mobile-hide-br" />
              how we can help your business succeed.
            </p>
          </div>

          {/* FAQ Section */}
          <section className="faq-section" data-aos="fade-up">
            <div className="faq-grid">
              {faqData.map((item, index) => (
                <div
                  key={index}
                  className={`faq-item ${openIndex === index ? "open" : ""}`}
                  onClick={() => toggleFAQ(index)}
                  // data-aos="fade-up"
                  // data-aos-delay={index * 100}
                >
                  
                  <div className="faq-question">
                    {item.question}
                    <span className="faq-icon">
                      {openIndex === index ? "−" : "+"}
                    </span>
                  </div>

                  <div
                    className={`faq-answer ${openIndex === index ? "show" : ""}`}
                  >
                    {item.answer}
                  </div>
                </div>
              ))}
            </div>
          </section>
        </div>
      </div>
    </>
  );
}

export default FAQ;
